import { ROUTE_NAMES } from "@root/constants";
import AuthLayout from "@root/layouts/AuthLayout";
import {
  CheckEmail,
  ForgotPassword,
  Login,
  ResetPassword,
  ResetSuccess,
  Signup,
  ContactUsScreen,
  PrivacyPolicy,
  TermsConditions,
  EmailVerification,
  AllSet,
  LetsStart,
  AwaitingApproval,
} from "@root/pages";
import { Navigate, createBrowserRouter } from "react-router-dom";
import { CountryProvider } from "@root/context";
import { LoginAdmin } from "@root/pages/auth/login/loginAdmin";
import { LoginUser } from "@root/pages/auth/login/loginUser";
import { LoginJournalist } from "@root/pages/auth/login/loginJournalist";
import { SignupEmailVerification } from "@root/pages/auth/emailVerification/SignupEmailVerification";
import Success from "@root/pages/success-account-creation/success";
import UnauthenticatedLayout from "@root/layouts/UnauthenticatedLayout";
import { UnauthenticatedDashboard } from "@root/components/UnauthenticatedDashboard/Index";
import UnauthenticatedCoursesPages from "@root/components/Unauthenticated-Courses/Index";
import FreeCourseDetail from "@root/components/Unauthenticated-Courses/FreeCoursesDetails";
import Notice from "@root/components/Notice/Index";

export const publicRoutes = createBrowserRouter([
  {
    path: "/",
    element: (
      <CountryProvider>
        <UnauthenticatedLayout />
      </CountryProvider>
    ),
    children: [
      {
        path: "*",
        element: <Navigate to="/" />,
      },
      {
        path: "/",
        element: <UnauthenticatedDashboard />,
      },
      {
        path: ROUTE_NAMES.UNAUTHENTICATED_COURSES,
        element: <UnauthenticatedCoursesPages />,
      },
      {
        path: `${ROUTE_NAMES.UNAUTHENTICATED_COURSE_DETAIL}/:id`,
        element: <FreeCourseDetail />,
      },
      {
        path: ROUTE_NAMES.UNAUTHENTICATED_NOTICE,
        element: <Notice />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <CountryProvider>
        <AuthLayout />
      </CountryProvider>
    ),
    children: [
      {
        path: ROUTE_NAMES.LOGIN,
        element: <LoginJournalist />,
      },
      {
        path: ROUTE_NAMES.SUPER_ADMIN_LOGIN,
        element: <Login />,
      },
      {
        path: ROUTE_NAMES.SINGUP,
        element: <Signup />,
      },
      {
        path: ROUTE_NAMES.PLEDGE_LOGIN,
        element: <LoginUser />,
      },
      {
        path: ROUTE_NAMES.JOURNALIST_LOGIN,
        element: <LoginJournalist />,
      },
      {
        path: ROUTE_NAMES.SIGNUP_EMAIL_VERIFICATION,
        element: <SignupEmailVerification />,
      },
      {
        path: ROUTE_NAMES.ADMIN_LOGIN,
        element: <LoginAdmin />,
      },
      {
        path: ROUTE_NAMES.EMAIL_VERIFICATION,
        element: <EmailVerification />,
      },
      {
        path: ROUTE_NAMES.ALL_SET,
        element: <AllSet />,
      },
      {
        path: ROUTE_NAMES.LETS_START,
        element: <LetsStart />,
      },
      {
        path: ROUTE_NAMES.FORGET_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: ROUTE_NAMES.RESET_PASSWORD,
        element: <ResetPassword />,
      },
      {
        path: ROUTE_NAMES.RESET_SUCCESS,
        element: <ResetSuccess />,
      },
      {
        path: ROUTE_NAMES.ACCOUNT_SUCCESS,
        element: <Success />,
      },
      {
        path: ROUTE_NAMES.CHECK_YOUR_EMAIL,
        element: <CheckEmail />,
      },
      {
        path: ROUTE_NAMES.CONTACT,
        element: <ContactUsScreen />,
      },
      {
        path: ROUTE_NAMES.PRIVACY_POLICY,
        element: <PrivacyPolicy />,
      },
      {
        path: ROUTE_NAMES.TERMS_CONDITION,
        element: <TermsConditions />,
      },
      {
        path: ROUTE_NAMES.AWAITING_APPROVAL,
        element: <AwaitingApproval />,
      },
    ],
  },
]);
